export const gstApplnInt = {
  103: 'Policy - Premium GST',
  105: 'Policy - Commission 1 GST',
  302: 'Policy - Commission 2 GST',
  402: 'Policy - Commission 3 GST',
  506: 'Facultative - Premium, GST',
  507: 'Facultative - Commission, GST',
  606: 'Coinsurance - Premium, GST',
  607: 'Coinsurance - Commission, GST',
  692: 'Coinsurance - Service Fee, GST',
  1001: 'Claim Payments',
  1002: 'Claim Payments, Input GST',
  1003: 'Claim Payments Output GST',
  1004: 'Claim Payments Deemed Input GST',
  1501: 'Claim Facultative Recoveries',
  1601: 'Claim Coinsurance Recoveries'// ,
  // 6001: 'Debtor Entry Income/Expense/Asset/Liability',
  // 6002: 'Debtors Entry, Input GST',
  // 6003: 'Debtors Entry, Output GST'
}
